/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { List, fromJS } from 'immutable';
import { RestAPI } from '../../../../util/net';
import { goBack } from '../../../../util/util.jsx';
import { putError } from '../../../../store/error.store';
import { REF_NAME, SUBTYPE_NAME } from './Const';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';

export const refLoaded = (state, action) => state.clear().merge(fromJS(action.data));

export const refUpdated = (state, action) =>
  state.map(ref =>
    (ref.get('id') == action.data.id ?
      ref.merge(fromJS(action.data)).set('id', ref.get('id')) : ref));

export const refUpdatedChild = (state, action) => {
  const prodIdx = state.findIndex(prod => prod.get('id') == action.data.productId);
  const idx = state.getIn([prodIdx, 'productTypes'])
    .findIndex(type => type.get('id') == action.data.id);
  return state.mergeIn([prodIdx, 'productTypes', idx],
    fromJS(action.data).set('id', Number(action.data.id)));
};

const setHidden = (state, action, hidden) => {
  const idx = state.findIndex(item => item.get('id') == action.id);
  if (idx > -1) {
    return state.setIn([idx, 'hidden'], hidden);
  } return state;
};

const setHiddenChild = (state, action, hidden) => {
  const product = state
    .find(item => item.get('productTypes').find(pt => pt.get('id') == action.id) != null);
  const parentIdx = state.indexOf(product);
  const childIdx = product.get('productTypes')
    .findIndex(pt => pt.get('id') == action.id);
  if (childIdx > -1) {
    return state.setIn([parentIdx, 'productTypes', childIdx, 'hidden'], hidden);
  }
  return state;
};

const refCreated = (state, action) =>
  state.push(fromJS({ ...action.data,
    productTypes: action.data.productTypes ? action.data.productTypes : [] }));

const refChildCreated = (state, action) => {
  const prodIdx = state.findIndex(prod => prod.get('id') == action.data.product.id);
  const productTypes = state.get(prodIdx).get('productTypes').push(fromJS(action.data));
  return state.setIn([prodIdx, 'productTypes'], productTypes);
};

export const refReducer = (state = List(), action) => {
  switch (action.type) {
    case `${REF_NAME}_LOADED`:
      return refLoaded(state, action);
    case `${REF_NAME}_UPDATED_SUCCESSFULLY`:
      return refUpdated(state, action);
    case `${REF_NAME}_DELETED`:
      return setHidden(state, action, true);
    case `${REF_NAME}_RESTORED`:
      return setHidden(state, action, false);
    case `${SUBTYPE_NAME}_LOADED`:
      return refLoaded(state, action);
    case `${SUBTYPE_NAME}_UPDATED_SUCCESSFULLY`:
      return refUpdatedChild(state, action);
    case `${SUBTYPE_NAME}_DELETED`:
      return setHiddenChild(state, action, true);
    case `${SUBTYPE_NAME}_RESTORED`:
      return setHiddenChild(state, action, false);
    case `${REF_NAME}_CREATED_SUCCESSFULLY`:
      return refCreated(state, action);
    case `${SUBTYPE_NAME}_CREATED_SUCCESSFULLY`:
      return refChildCreated(state, action);
    default:
      return state;
  }
};

export const refDelete = (dispatch, refName, refPath, id) => {
  dispatch({ type: `${refName}_DELETE_STARTED` });
  return RestAPI.delete(`/references/${refPath}/api/${id}`)
    .catch((data) => {
      putError(dispatch, data);
      dispatch({ type: `${refName}_DELETE_FAILED` });
      return true;
    });
};

export const refRestore = (dispatch, refName, refPath, id) => {
  dispatch({ type: `${refName}_RESTORE_STARTED` });
  return RestAPI.patch(`/references/${refPath}/api/restore/${id}`)
    .catch((data) => {
      putError(dispatch, data);
      dispatch({ type: `${refName}_RESTORE_FAILED` });
      return true;
    });
};

export const refLoad = (dispatch, refName, refPath) => {
  markStoreLoading(dispatch, refName);
  dispatch({ type: `${refName}_LOADING_STARTED` });
  return RestAPI.get(`/references/${refPath}/api`)
    .then((data) => {
      dispatch({ type: `${refName}_LOADED`, data });
      markStoreLoaded(dispatch, refName);
      return true;
    }).catch(() => true);
};

export const refUpdate = (dispatch, refDto, refName, refPath) => {
  dispatch({ type: `${refName}_UPDATE_STARTED`, data: refDto });
  return RestAPI.patch(`/references/${refPath}/api/${refDto.id}`, refDto)
    .then(() => {
      goBack(`/references/${refPath}/${refDto.id}`);
      return true;
    }).catch((data) => {
      putError(dispatch, data);
      dispatch({ type: `${refName}_UPDATE_FAILED` });
      return true;
    }
    );
};

export const refCreatePromise = (url, refDto) =>
  RestAPI.put(url, refDto);

function create(dispatch, refDto, refName, refPath, url) {
  dispatch({ type: `${refName}_CREATE_STARTED`, data: refDto });
  return refCreatePromise(url, refDto)
    .then((response) => {
      goBack(`/references/${refPath}/${response.id}`);
      return true;
    }).catch((data) => {
      putError(dispatch, data);
      dispatch({ type: `${refName}_CREATION_FAILED` });
      return true;
    }
    );
}

export const refCreateChild = (dispatch, refDto, refName, refPath) => {
  create(dispatch, refDto, refName, refPath, `/references/${refPath}/api/${refDto.productId}`);
};

export const refCreate = (dispatch, refDto, refName, refPath) => {
  create(dispatch, refDto, refName, refPath, `/references/${refPath}/api`);
};
